import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["disabled", "error", "inputUse", "onChange", "onBlur", "readOnly", "value"];
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { NumberInput } from 'foundations-components/transitional/components/NumberInput';
import { InputStaticLabel } from 'foundations-components/transitional/components/InputStaticLabel';
import { Text } from 'foundations-components/components/Text';
import { getTransferableProps } from './filterInputProps';
import { jsx as _jsx } from "react/jsx-runtime";
const FilterOperatorCountInput = props => {
  const {
      disabled,
      error,
      inputUse,
      onChange,
      onBlur,
      readOnly,
      value
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const isError = error.get('error');
  const errorMessage = error.get('message');
  const transferableProps = getTransferableProps(rest);
  const {
    ['data-selenium-test']: dataSeleniumTest,
    placeholder
  } = transferableProps;
  return /*#__PURE__*/_jsx(FormControl, {
    "aria-label": I18n.text('customerDataFiltersUI.customerDataFilters.FilterOperatorInput.ariaLabel'),
    error: isError,
    validationMessage: isError ? errorMessage : null,
    children: /*#__PURE__*/_jsx(InputStaticLabel, {
      text: /*#__PURE__*/_jsx(Text, {
        as: "span",
        color: disabled ? 'fill-field-disabled' : undefined,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFiltersUI.customerDataFilters.FilterOperatorCountInput.label"
        })
      }),
      position: "end",
      children: /*#__PURE__*/_jsx(NumberInput, {
        "data-selenium-test": dataSeleniumTest,
        placeholder: placeholder,
        use: inputUse,
        disabled: disabled,
        onBlur: onBlur,
        onChange: onChange,
        readOnly: readOnly,
        value: value
      })
    })
  });
};
export default FilterOperatorCountInput;